import { useContext } from "react";
import * as Scrivito from "scrivito";
import CurrentPageMetadata from "^/Components/CurrentPageMetadata";
import Navigation from "^/Components/Navigation";
import Footer from "^/Components/Footer";
import NotFoundErrorPage from "^/Components/NotFoundErrorPage";
import CookieConsent from "^/Components/CookieConsent";
import Disturber from "^/Components/Disturber";
import Notifier from "^/Components/Notifier";

import getHomepage from "^/utils/getHomepage";
import { useMatomo } from "^/hooks/useMatomo";
import { useMatomoPageTracking } from "^/hooks/useMatomoPageTracking";
import { isLiv, isIntranet } from "^/utils/isLiv";
import { CookieConsentContext } from "./CookieConsentContext";
import { StudiAssistChat } from "./StudiAssistChat";

function getMatomoSiteId(homepage) {
  if (isLiv(homepage)) return "4";
  if (isIntranet(homepage)) return "1";
  return "2";
}

function PageWrapper() {
  const currPage = Scrivito.currentPage();
  const currPageId = currPage?.id();
  const homepage = getHomepage(currPage);
  const themeColor = homepage?.get("backgroundColor") || "blue";
  const { optionAllowed } = useContext(CookieConsentContext);
  const trackingAllowed = optionAllowed("matomo");
  const showAiChat = currPage?.get("showAiChat");

  useMatomo({
    siteId: homepage && getMatomoSiteId(homepage),
    trackerUrl: "https://matomo.rz.hs-heilbronn.de/",
    allowed: trackingAllowed,
  });

  useMatomoPageTracking(currPageId, trackingAllowed);

  return (
    <>
      <div className={`content-wrapper theme-${themeColor}`}>
        <Notifier />
        <Navigation />
        <Disturber />
        <Scrivito.CurrentPage />
        <Footer />
        <CookieConsent />
        <NotFoundErrorPage />
      </div>
      <CurrentPageMetadata />
      {showAiChat && <StudiAssistChat page={currPage} homepage={homepage} />}
    </>
  );
}

export default Scrivito.connect(PageWrapper);
